import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { ListItemAvatar } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";


export default function TeamListItem({ team, onClick, itemClasses }) {

  const { TeamName, TeamNo } = team;
  const handleClick = (e) => onClick && onClick(e);

  return (
    <ListItem
      dense
      disableGutters
      onClick={handleClick}
      className={itemClasses}
      data-testid={'li-item-' + team.id}
    >
      <ListItemAvatar>
        <PersonOutlineIcon />
      </ListItemAvatar>
      <ListItemText
        secondary={TeamName}
        primary={TeamNo}
        primaryTypographyProps={{ className: "bold" }}
      />
    </ListItem>
  );
}
